<button class="button-blue" style="width: 150px;">
    Save
</button>
